<template>
  <div class="language">
    <swithLanguage></swithLanguage>
  </div>
  <div class="hello">
    <img src="../assets/logo.png" class="logo" @click="gourl">
    <div class="slgon" @click="test">{{ $t('index.slogan') }}</div>
    <div class="text"> {{ $t('index.customText') }}</div>
    <div>
      <input v-model="password" class="input" :placeholder="$t('index.placeholder')">
      <input v-model="password_user" type="password" class="input" :placeholder="$t('index.placeholder_user')">
      <div style="margin-top: 20px;">
        <el-radio v-model="radio" style="color: #fff;" label="tiktok" border>TikTok</el-radio>
        <el-radio v-model="radio" style="color: #fff;" label="bigo" border>bigo</el-radio>
      </div>
      <el-button @click="go" type="primary" size="large" color="#636ff1"
        style="margin-left: 20px;height: 40px;margin-top: 20px;">
        {{ $t('index.goButton') }}
      </el-button>
    </div>
    <!-- <div class="bottom">
      星遇互游 © 2024 All Rights by 湖北千纳文化发展有限公司.<br>
      鄂ICP备2021020027号-1
    </div> -->
  </div>
</template>

<script>
import { ElLoading, ElMessage } from 'element-plus'
import { post } from "@/api";
import swithLanguage from "@/components/swithLanguage.vue";

export default {
  name: 'HelloWorld',
  components: { swithLanguage },
  data() {
    return {
      password: "",
      options: [],
      value: '',
      password_user: "",
      radio: "tiktok"
    }
  },
  created() {

    if (window.localStorage.getItem("platform")) {
      this.radio = window.localStorage.getItem("platform")
    }

    if (this.$route.query.user) {
      this.password = this.$route.query.user
      if (this.$route.query.key) {
        this.get(this.$route.query.key);
      }
    } else if (this.$route.query.anchor_user && this.$route.query.anchor_password) {
      this.password = this.$route.query.anchor_user
      this.password_user = this.$route.query.anchor_password
      this.go()
    }

    console.log(this.$route.query)
  },
  methods: {
    test() {
      // window.chrome.webview.postMessage(JSON.stringify({
      //   type: "openNewTool", key: "N493euAgQqPqOmr6q0d7jwQEtAmouE8+d58r7lMe5sg=", token: "tool_74657374303032333a313735333236303530373a616e74695f63686561745f746f6f6c",
      // }));
    },
    get(key) {
      post("/get_role", {
        "user": this.password,
        "key": key
      }).then(res => {
        if (res.code == 200) {
          this.password_user = res.data
        }
        console.log(res)
      }).catch(res => {
        console.log(res)
      })
    },
    go() {

      if (!this.radio) {
        ElMessage.error(this.$t('notify.platformNULL'))
        return;
      }
      if (!this.password || !this.password_user) {
        ElMessage.error(this.$t('index.placeholder'))
        return;
      }

      const loading = ElLoading.service({
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })

      post("/login", {
        "user": this.password,
        "password": this.password_user,
        "platform": this.radio
      }).then(res => {
        loading.close()
        if (res.data["errorCode"] == 106 || res.code == 400 || res.data["errorCode"] == 1) {
          console.log(res.data)
          ElMessage.error(this.$t('newNotify.' + res.data["i18"]))
        } else if (res.data["errorCode"] == 0) {
          console.log(res.data)
          window.localStorage.setItem("platform", this.radio)
          window.localStorage.setItem("data", JSON.stringify(res.data))
          this.$router.push("/pay")
        }
      }).catch(res => {
        loading.close()
        ElMessage.error(this.$t('newNotify.networkError'))
        console.log(res)
      })
    },
    gourl() {
      window.location.href = "https://www.xyhy.live"
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo {
  width: 200px;
  height: auto;
  position: fixed;
  top: 20px;
  left: 20px;
}

.slgon {
  margin-top: 10%;
  font-size: 5rem;
  font-weight: bold;
  background: linear-gradient(to right, #2665EA 0%, #4ADC83 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-block;
  padding: 5px;
}

.text {
  font-size: 24px;
  color: #6B7280;
  margin-top: 100px;
  font-weight: bold;
}

.input {
  width: 15%;
  height: 40px;
  margin-top: 100px;
  border-radius: 5px;
}

.select {
  width: 7%;
  min-width: 100px;
}

.bottom {
  color: #6B7280;
  font-weight: bold;
  font-size: 15px;
  position: fixed;
  width: 100%;
  bottom: 20px;
}

.language {
  position: absolute;
  right: 20px;
  top: 40px;
}
</style>
